var MULTIPLIER = 2;
var AVERAGE_LETTER_WIDTH = 7 * MULTIPLIER;
var OPTION_PADDING = 18 * MULTIPLIER;
var RIGHT_MARGIN = 8 * MULTIPLIER;
var CLOSE_BUTTON_WIDTH = 26 * MULTIPLIER;
var OPTION_NAME_LENGTH_TRESHOLD = Math.floor(12 * MULTIPLIER);
export function getOptionWidth(option) {
    var name = option.name;
    var trimmedName = trimOptionName(String(name));
    var letters = trimmedName.length || 0;
    var optionWidthInPx = letters * AVERAGE_LETTER_WIDTH +
        OPTION_PADDING +
        CLOSE_BUTTON_WIDTH +
        RIGHT_MARGIN;
    return optionWidthInPx;
}
/**
 * Helper function to get the count of numbers in an array that summed up are less than a given number
 * @param numbers
 * @param number
 * @returns numbers
 */
export function getAmountOfNumbersSumLessThan(numbers, number) {
    var sum = 0;
    var amount = 0;
    for (var i = 0; i < numbers.length; i++) {
        sum += numbers[i];
        if (sum > number) {
            break;
        }
        amount++;
    }
    return amount;
}
export function getAmountOfOptionsThatFitInContainer(options, containerWidth) {
    var optionsWidths = options.map(function (option) { return getOptionWidth(option); });
    return getAmountOfNumbersSumLessThan(optionsWidths, containerWidth);
}
export function trimOptionName(name) {
    if (name.length < OPTION_NAME_LENGTH_TRESHOLD) {
        return name;
    }
    // Subtract a proportional value to fit the ellipsis while keeping the same aspect
    return name.slice(0, OPTION_NAME_LENGTH_TRESHOLD - Math.floor(2 * MULTIPLIER)) + "...";
}
